import { Component, Input } from '@angular/core';
import { PatientAttachment } from 'app/core/models/patient-attachment.model';

import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-patient-attachment-duplicate-link',
    templateUrl: './patient-attachment-duplicate-link.component.html',
    styleUrl: './patient-attachment-duplicate-link.component.scss',
    imports: [RouterLink]
})
export class PatientAttachmentDuplicateLinkComponent {
  @Input() patientAttachment: PatientAttachment;
}
